
window.cart = {
    $processing: $('#cart-processing'),
    spinner: '<i class="fa fa-spinner fa-spin"></i>',
    $shoppingCartIcon: $('#shopping-cart-icon'),

    incrementCount: function (el) {
        return new Promise((resolve) => {
            this._getDomElements(el);
            this._getDomInformation();
            this._setNewQty(1);
            this._changeQty(resolve, el);
        })
    },
    decrementCount: function (el) {
        this._getDomElements(el);
        this._getDomInformation();
        this._setNewQty(-1);
        this._changeQty();
    },
    changeLineItemQty: function (el) {
        this._getDomElements(el);
        this._getDomInformation();
        let $input = $(el);
        this._setNewQty(0, $input.val());
        this._changeQty(null, el);
    },


    // sets the common variables for the cart object based on the currently used row
    $form: undefined,
    $buttonGroup: undefined,
    $qty: undefined,
    $tr: undefined,
    $input: undefined,
    $subtotal: undefined,
    _getDomElements: function (el) {
        this.$form = $(el).closest('form');
        this.$buttonGroup = this.$form.closest('.add-classes');
        this.$qty = this.$form.find('input[name="qty"]');
        this.$tr = this.$form.parents('tr');
        this.$input = this.$form.find('.total');
        this.$price = this.$tr.find('td:last-of-type p.original-price');
        this.$salePrice = this.$tr.find('td:last-of-type p.sale-price');
    },

    // Get information from twig and Craft
    stock: undefined,
    unlimited: undefined,
    maximumQty: undefined,
    lineItemId: undefined,
    variantItemId: undefined,
    _getDomInformation: function (addQty, newQty) {
        this.stock = this.$form.data('stock');
        this.unlimited = this.$form.data('unlimited');
        this.maximumQty = this.$form.data('max') || 1000000;
        this.lineItemId = this.$input.data('lineitemid');
        this.variantItemId = this.$input.data('variantitemid');
    },

    oldQty: undefined,
    addQty: undefined,
    newQty: undefined,
    _setNewQty: function (addQty, newQty) {
        this.oldQty = parseInt(this.$input.data('oldqty'));

        this.newQty = this.oldQty + addQty;
        this.addQty = addQty;

        if (newQty) {
            this.newQty = newQty;
            this.addQty = this.oldQty - newQty;
        }

        // error checking for invalid new quantities
        // @TODO: set addQty values also
        if (this.newQty < 0) {
            this.newQty = 0;
        }
        if (this.newQty > this.stock && !this.unlimited) {
            this.newQty = this.stock;
        }
        if (this.newQty > this.maximumQty) {
            this.newQty = this.maximumQty;
        }

        // since we have set a new value, we will want to save it for next change
        this.$input.data('oldqty', this.newQty);
        // set the input to the correct value now
        this.$input.val(this.newQty);
    },

    _changeQty: function (callback, el) {
        // @TODO: Bring back spinner
        // $input.html(this.spinner);
        // this.$processing.show();
        const cartQuantityChangedEvent = new Event("cartQuantityChanged");
        const serializedData = this.$form.serialize();

        window.alert.toast("Updating cart...", "info", {
            showLoading: true
        });

        let self = this;
        // Update cart via AJAX
        $.ajax({
            url: '',
            data: serializedData,
            type: 'POST',
            dataType: 'json',
            error: function (data) {
                console.log('error: _changeQty', data);
                window.alert.toast(data.responseText, 'error');
            },
            complete: function (data) {
                // console.log('complete: _changeQty', data);
                // console.log('complete: _changeQty');
                let cart = data.responseJSON.cart;

                // Check for line items count
                if(cart.lineItems.length == 0) {
                    // Hide the cart and show empty cart block
                    $('#full-cart').hide();
                    $('#empty-cart').show();
                    startFeaturedProductCarousel();
                }
                
            },

            success: function (data, textStatus, jqXHR) {
                // console.log('success: _changeQty', data);
                // console.log('success: _changeQty');

                // if(data.success){
                if(jqXHR.status === 200) {
                    document.dispatchEvent(cartQuantityChangedEvent);
                    self.updateTotalsChangeQty(data.cart);
                    self.updateTotals(data.cart);
                    self.updateShippingInformation();
                    self.updateShoppingCartBadgeTotalQty();
                }

                let errorText = null;
                if(data.errors){
                    errorText = '';
                    for(const error in data.errors){
                        errorText = errorText + '<div>' + data.errors[error][0] + '</div>';
                    }

                    // If the element is available, attempt to decrease the input value to restore the original value
                    if(el){
                        const $input = $(el);
                        self._setNewQty(0, $input.val() - 1);
                    }
                }
                // console.log(data);

                let message = data.message;

                // window.alert.toast(message, data.success ? 'success' : 'error', {
                window.alert.toast(message, jqXHR.status === 200 ? 'success' : 'error', {
                    html: errorText
                });

                // if(data.success && typeof callback === 'function') {
                if(jqXHR.status === 200 && typeof callback === 'function') {
                    setTimeout(() => {
                        callback();
                    }, 2000);
                }
            },
        });
    },

    updateShoppingCartBadgeTotalQty: function(){
        $.ajax({
            method: 'GET',
            url: '/actions/montavilla/commerce/get-cart-items-count',
            success: function (response) {
                let $badge = $('.items-count-badge', this.$shoppingCartIcon);
                const qty = parseInt(response);
                if(qty > 0){
                    if(qty > 9){
                        $badge.addClass('doubleDigits');
                    }
                    else {
                        $badge.removeClass('doubleDigits');
                    }
                    $badge.show().html(response);
                }
                else {
                    $badge.removeClass('doubleDigits').hide();
                }
            }
        })
    },

    updateTotalsChangeQty: function (cart) {
        // look through items in the cart
        // and remember the item for the current variant
        let currentItem;
        for (let i in cart.lineItems) {
            let item = cart.lineItems[i];
            if (this.variantItemId === item.snapshot.purchasableId) {
                currentItem = item;
            }
        }

        // if there is already an item in the cart, we will update it from the data
        if (currentItem) {
            this.$input.attr('name', `lineItems[${currentItem.id}][qty]`);
            this.$input.val(currentItem.qty);
            // console.log('this is the current item');
            // console.log(currentItem);
            this.$price.html("<strike>"+currentItem.priceAsCurrency+"</strike>");
            this.$buttonGroup.addClass('added');
        } else {
            this.$input.attr('name', 'qty');
            this.$input.val(0);
            this.$price.html('$0');
            this.$buttonGroup.removeClass('added');
        }

        if (this.newQty >= this.stock) {
            this.$buttonGroup.addClass('maximum');
        } else {
            this.$buttonGroup.removeClass('maximum');
        }
        if (this.unlimited) {
            this.$buttonGroup.removeClass('maximum');
        }
    },

    removeItem: function (lineItemId) {
        let agree = confirm("Are you sure you want to remove this item?");
        if (agree) {
            let $tr = $('#cart-' + lineItemId);
            $tr.find('input.total').val(0);
            $tr.find('input.total').trigger('change');
            $tr.hide();
        }
    },

    changeDiscountCode: function (e) {
        if(e !== undefined) {
            e.preventDefault()
        }
        let $form = $('#discount-code-form');
        $form.find('input[name="couponCode"]').val('');
        $form.trigger('submit');
    },

    applyDiscountCode: function (callback) {
        console.log(callback);
        let code = $('#discount-field').find('input[name="couponCode"]').val();
        let form = $('#discount-code-form');
        let $currentCode = $('#current-code');
        $('.discount-state').hide();
        let data = form.serialize();
        if (code !== undefined) {
            $.ajax({
                type: "POST",
                dataType: 'json',
                url: '',
                data: data,
                success: function (data, textStatus, jqXHR) {
                    // if (data.success) {
                    if (jqXHR.status === 200) {
                        console.log(data);
                        // Remove table row
                        $currentCode.text(code);
                        $('#discount-code').show();
                        cart.updateTotals(data.cart);
                    } else {
                        $currentCode.text('');
                        $('#discount-message').show();
                        alert('Invalid discount code.');
                    }
                },
                error: function (data) {
                    console.log(data);
                    $currentCode.text('');
                    $('#discount-message').show();
                    alert('Invalid discount code.');
                    return;
                }
            });
        }
    },


    // more of a general function to update for remove cart / update cart / discount code / etc
    updateTotals: function (cart) {
        let shippingCosts;

        if(cart.totalShippingCost !== undefined) {
            shippingCosts = cart.totalShippingCost;
        }
        else {
            for (const key in cart.availableShippingMethods) {
                if (key == cart.shippingMethodHandle) {
                    const element = cart.availableShippingMethods[key];
                    shippingCosts = element.rate;
                }
            }
            if (!shippingCosts) {
                shippingCosts = 0;
            }
        }

        // this may not be accurate right now
        $('#cart-subtotal').text(cart.itemSubtotalAsCurrency);
        $('#cart-discount').text(cart.totalDiscountAsCurrency);
        $('#cart-total').text(cart.totalPriceAsCurrency);

        $('#cart-shipping').text(`$${shippingCosts.toFixed(2)}`);
        $('#shipping-method-price').text(`$${shippingCosts.toFixed(2)}`);

        if(cart.lineItems.length) {
            $('.c-floating-cart').addClass('visible');
        } else {
            $('.c-floating-cart').removeClass('visible');
        }
    },

    listenForShippingChange: function () {
        $('input[type="radio"][name="shippingMethodHandle"]').on('change', (el) => {
            this.updateCartShippingMethod(el.target);
        });
    },

    // after a radio button is selected, this function will be called
    updateCartShippingMethod: function (input) {
        let $input = $(input);
        let $form = $input.parents('form');
        let self = this;
        $.ajax({
            type: "POST",
            dataType: 'json',
            url: '',
            data: $form.serialize(),
            success: function (data, textStatus, jqXHR) {
                console.log('success: updateCartShippingMethod', data);
                // if (data.success) {
                if (jqXHR.status === 200) {
                    self.updateTotals(data.cart);
                    window.alert.toast('The shipping method has been updated.')
                } else {
                    alert('Invalid shipping method');
                }
            },
            error: function (data) {
                alert(data.responseText);
                console.log(data.responseText);
                console.log('error: updateCartShippingMethod', data);
                return;
            }
        });
    },

    // check to see if all the items in the cart are events
    // if that is true, then we can hide the shipping method information
    _checkDisplayShippingMethods: function (cart) {
        // 1. General
        // 2. Products
        // 3. Events
        // 6. In-store Pick Up
        let lineItemShippingIds = cart.lineItems.map((e) => {
            return e.shippingCategoryId
        });
        // console.log(lineItemShippingIds);
        if (lineItemShippingIds.includes(2)) {
            $('.shipping-select-section').show();
        } else {
            $('.shipping-select-section').hide();
        }
    },


    // will send a query off to craft for the shipping information
    // this may be needed for unknown reasons in postie
    // the delay from making two queries, or two calls to update cart
    // is required right now to get more accurate shipping information
    updateShippingInformation: function () {
        let self = this;
        $.ajax({
            method: "POST",
            dataType: 'json',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            url: '/',
            data: {
                'action': 'commerce/cart/get-cart',
                [window.csrfTokenName]: window.csrfTokenValue
            },
            success: function (data) {
                // console.log('success: updateShippingInformation', data);
                self._checkDisplayShippingMethods(data.cart);
                self._setShippingOptionsRadioButtons(data.cart);
                self.updateTotals(data.cart);
            }
        });
    },


    // create html for the "new" shipping methods in the cart
    _setShippingOptionsRadioButtons: function (cart) {
        let finalTemplate = '';
        for (const property in cart.availableShippingMethodOptions) {
            let shippingMethod = cart.availableShippingMethodOptions[property];
            let template = `<div class="shipping-select" id="${property}-shipping-method">
                <label>
                    <input type="radio" name="shippingMethodHandle" value="${property}" ${cart.shippingMethodHandle == shippingMethod.handle ? 'checked' : ''}/>
                    <strong>${shippingMethod.name}</strong>
                    <span class="price">${shippingMethod.priceAsCurrency}</span>
                </label>
            </div>`;
            finalTemplate = finalTemplate + template;
        }
        $('.shipping-method-options').html('');
        $('.shipping-method-options').html(finalTemplate);

        // re-apply the event listeners for the new radio buttons
        this.listenForShippingChange();
    },


    init: function () {
        // console.log(cart.stock);
        // Apply discount code when pressing Enter
        $('#discount-field').find('input').on('keyup', function (e) {
            if (e.keyCode === 13) { // Enter
                cart.applyDiscountCode();
            } else if (27 === e.keyCode) { // Esc
                $('.discount-state').hide();
                let current = $('#current-code').text();
                if (current) {
                    $('#discount-code').show();
                } else {
                    $('#discount-message').show();
                }
            }
        });

        this.updateShippingInformation();
        this.listenForShippingChange();
    },





    addToWaitList: function (variantId) {
        let beforeMessage = 'How many seats would you like?';
        let afterMessage = 'Thank you! You have been added to the waiting list. You will receive a confirmation email.';
        let errorMessage = 'Something went wrong.'; // Returned in AJAX response
        // ---------------------------------------------------------------------- //
        let requestedSpots = prompt(beforeMessage, 1);
        if (requestedSpots) {
            setTimeout(function () {
                // Set AJAX request data
                let requestData = {
                    'variantId': variantId,
                    'requestedSpots': requestedSpots
                };
                requestData[window.csrfTokenName] = window.csrfTokenValue;
                Swal.fire({
                    title: 'Adding to the waiting list',
                    didOpen: () => {
                        Swal.showLoading()
                    }
                });
                // Add to wait list
                $.post('/actions/enrollment/enrollment/update-waiting-list', requestData, function (response) {
                    Swal.close();
                    if (response && Boolean(Number(response))) {
                        window.alert.toast(afterMessage, 'success', {position: 'center', timer: 5000});
                    } else {
                        window.alert.toast(errorMessage, 'error', {timer: 5000});
                    }
                })
                    .fail(function() {
                        window.alert.toast(errorMessage, 'error', {timer: 5000});
                    });
            }, 50); // Allows time for spinner to display
        }
    },
};

$(function () {
    cart.init();

    /**
     * Add a product to the cart and redirects to the checkout page
     */
    $('.js-buy-now').on('click', function(event){
        event.preventDefault(); // Prevent default button behavior if necessary

        const $this = $(this); // Correctly reference the clicked button
        const formId = $this.data('formid'); // Get the form ID from data-formid attribute

        console.log(formId); // Debugging: Log the form ID

        // Ensure formId exists and is a valid selector.
        if (!formId) {
            console.error('Form ID not found on the clicked button.');
            return;
        }

        const $form = $(formId); // Select the specific form

        if ($form.length) { // Check if the form exists
            const $plusButton = $form.find('.fa-plus-circle'); // Find the plus button within the form

            if ($plusButton.length) { // Check if the plus button exists
                const $total = $form.find('.total'); // Find the total input within the form

                if ($total.length) { // Check if the total input exists
                    const totalValue = parseFloat($total.val()); // Get the numerical value

                    if (isNaN(totalValue)) {
                        console.error('Total value is not a number.');
                        return;
                    }

                    if (totalValue <= 0){
                        cart.incrementCount($plusButton[0])
                            .then(function(){
                                // Optionally redirect to the cart page
                                // window.location.href = '/cart';
                            })
                            .catch(function(error){
                                console.error('Error incrementing cart count:', error);
                            });
                    }
                    else {
                        // Optionally redirect to the cart page
                        // window.location.href = '/cart';
                    }
                } else {
                    console.error('Total input not found within the form.');
                }
            } else {
                console.error('Plus button not found within the form.');
            }
        } else {
            console.error(`Form with ID "${formId}" not found.`);
        }
    });

});

